<div data-test-id="spacer" [ngStyle]="{ height }"></div>
